import { FormControl,  ValidationErrors } from '@angular/forms';
import { isNullOrEmpty } from '@awp/core/utils';

const EMAIL_REGEX = /^[a-zA-Z0-9-.+_]+@((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,}$/

const ALPHA_REGEX = /^[a-zA-Z]*$/;
const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9 ]*$/;
const NAME_REGEX = /^[a-zA-Z](((?![-\'\s]{2,})[a-zA-Z- \'])*[a-zA-Z])*$/;
const ADDRESS_REGEX = /^[a-zA-Z0-9-. \/\']*$/;
const POSTCODE_REGEX = /^[0-9]{4,4}$/;

export class StringValidator {

  static email(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    const result = control.value.indexOf('..') === -1 && EMAIL_REGEX.test(control.value) ? null : { email: true };
    return result;
  }

  static AlphaOnly(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    return ALPHA_REGEX.test(control.value) ? null : { invalid: true };
  }

  static PersonName(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    return NAME_REGEX.test(control.value) ? null : { invalid: true };
  }

  static AlphaNumericOnly(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    return ALPHA_NUMERIC_REGEX.test(control.value) ? null : { invalid: true };
  }


  static Address(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    return ADDRESS_REGEX.test(control.value) ? null : { invalid: true };
  }

  static PostCode(control: FormControl): ValidationErrors | null {
    if (isNullOrEmpty(control.value)) {
      return null;
    }

    return POSTCODE_REGEX.test(control.value) ? null : { invalid: true };
  }

}
